import { App } from "antd";
import { useTranslation } from "react-i18next";
import { DataUpdate } from "@/hooks/useDataUpdate";
import { UpdateByKey } from "@/apis/order";
import { useState } from "react";
import { SaleOrderItemState } from "@/types/sales";

interface UsePassed {
  setId: (id: string) => void;
  updateApi: DataUpdate<[string, UpdateByKey], void>;
  handleOk: (id: string) => void,
  errorTip: string;
}

const usePassed = ({
  setId,
  updateApi,
  handleOk,
  errorTip
}: UsePassed) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [loading, setLoading] = useState<boolean>(false);

  const passed = (record: SaleOrderItemState) => {
    setLoading(true)
    let error = '';
    if (!record.innerNumber) {
      error = t("sale.innerNumberPre")
    }
    // else if (!record?.items?.[0]?.priceHisId && !record.productId) {
    //   error = t("sale.productPre")
    // }
    if (error) {
      setLoading(false)
      notification.error({ placement: 'top', message: errorTip, description: error })
      return;
    }
    setId(record.id);
    return updateApi(record.id, { key: "preApproval", value: 1 })
      .then(() => {
        handleOk(record.id)
        notification.success({ placement: 'top', message: t('sale.passSuccess') })
      })
      .finally(() => {
        setId('')
        setLoading(false)
      })
  }

  return { passed, loading }
}

export default usePassed;